define('collections/customer_managers',['require','collections/base','models/customer_manager'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/customer_manager");

    return BaseCollection.extend({
        model: Model,
        url: 'customer-managers.json'
    });
});

